import type { CreateBioscope } from '@/services/types';

import type { NewBioscopeInput } from './types';

function optionalId(value: string): number | undefined {
    return value === '' ? undefined : Number.parseInt(value);
}

/** An empty field leaves the id out, so the backend picks the next free one. */
export function toCreateBioscopeBody(input: NewBioscopeInput): CreateBioscope {
    return {
        clientId: optionalId(input.clientId),
        bioscopeId: optionalId(input.bioscopeId),
    };
}
